// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.application.SatelliteWebLandlordApplicationHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  SatelliteWebLandlordApplicationApplicationsAcceptedRequestDto,
  SatelliteWebLandlordApplicationInviteToApplyRequestDto,
} from '../..';

export const SatelliteWebLandlordApplicationHandler_applicationsAccepted_Path =
  '/api/web/landlord/v1/application/applicationsAccepted';

/**
 * Enable applications accepted for a listing
 */
export const SatelliteWebLandlordApplicationHandler_applicationsAccepted = (
  postData: SatelliteWebLandlordApplicationApplicationsAcceptedRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordApplicationApplicationsAcceptedRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordApplicationHandler_applicationsAccepted_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordApplicationHandler_inviteToApply_Path =
  '/api/web/landlord/v1/application/inviteToApply';

/**
 * Invite a renter to apply for a property
 */
export const SatelliteWebLandlordApplicationHandler_inviteToApply = (
  postData: SatelliteWebLandlordApplicationInviteToApplyRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordApplicationInviteToApplyRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordApplicationHandler_inviteToApply_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
